@for (childrenItem of child?.children | orderBy: 'name'; track $index) {
  <button
    (click)="selectChild($event, childrenItem)"
    [disabled]="childrenItem.disabled || childrenItem.blocked"
    [ngStyle]="{'padding-left': paddingLevel}"
    [ngClass]="{
      'common-dropdown-list__si-button-cascade--disabled-red': childrenItem.blocked
    }"
    class="common-dropdown-list__si-button-cascade">
    <span
      [ngClass]="{
        'common-dropdown-list__si-button-inner-border': childrenItem.open,
        'common-dropdown-list__si-button-inner': !childrenItem.open
      }">
      @if (childrenItem.children?.length) {
        <i
          [ngClass]="childrenItem.open ? 'lf-icon-angle-up' : 'lf-icon-angle-down'"
          (click)="openChildren($event, childrenItem)"
          class="common-icon__sm">
        </i>
      }
      <span-tooltip
        class="common-dropdown-list__si-text-container"
        [text]="childrenItem.name">
      </span-tooltip>
    </span>
  </button>
  @if (child.children.length && child.open) {
    <filials
      class="w-full"
      [child]="childrenItem"
      [level]="nextLevel"
      (openChildEmit)="openChildOn($event)"
      (selectChildEmit)="selectChildOn($event)" >
    </filials>
  }
}
